import { useMemo } from 'react';

/**
 * Generic hook that derives unique, sorted `{ value, text }` options from a data set.
 * Useful for building text-match or select filter option lists.
 */
export const useFilterOptions = <T>(
  data: T[],
  accessor: (item: T) => string
): { value: string; text: string }[] => {
  return useMemo(
    () =>
      Array.from(new Set(data.map(accessor)))
        .sort()
        .map(v => ({ value: v, text: v })),
    [data, accessor]
  );
};
